import React from "react";

export default function PageContainer(props) {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        padding: 8,
        maxWidth: "calc(100% - 16px)",
      }}
    >
      {props.children}
    </div>
  );
}
